import BaseAbility from 'umg-ember-backend/abilities/base';

export default class NewsletterTargetAbility extends BaseAbility {
  get canCreate() {
    return false;
  }

  get canDelete() {
    return false;
  }

  get canRead() {
    return false;
  }
}
